import SideBarItemExpanded from './SideBarItemExpanded'
import SideBarItem from './SideBarItem'
import {
  NAVIGATION, sideBarItemsCoach, sideBarItemsCoachWithoutCommunity, sideBarItemsAdmin, sideBarItemsLeadCoach,
} from '../../../misc/Constants'
import { hasCommunity } from '../../../utility/userHelper'
import { useTranslated } from '../../../i18n'
import { translateSidebarItems } from '../../../utility/i18nConverters'
import styles from '../../../assets/styles/components/common/ExpandableSideBar.module.scss'
import { useSelector } from 'react-redux'
import SideBarLegalLinks from './SideBarLegalLinks'

const SideBarNavigationItems = () => {
  const user = useSelector( state => state.user.current_user )
  const navigation = useSelector (state => state.ui.sideBarState)
  const collapsed = navigation === NAVIGATION.COLLAPSED

  const coachItems = hasCommunity(user) ? sideBarItemsCoach(user.communities[0].id) : sideBarItemsCoachWithoutCommunity
  const userPermissions = {
    Admin: sideBarItemsAdmin,
    Coach: user.lead_coach ? [...coachItems, ...sideBarItemsLeadCoach] : coachItems,
  }
  const items = useTranslated(userPermissions[user.type], translateSidebarItems)

  return (
    <div className={collapsed ? styles.navigationItems : styles.navigationItemsExpanded}>
      {items.map((item, index) => collapsed ?
        <SideBarItem key={item.title}
          icon={item.icon}
          title={item.title}
          index={index}
          links={item.links}/> :
        <SideBarItemExpanded key={item.title} icon={item.icon} title={item.title} index={index} links={item.links}/>)}
      {!collapsed && <SideBarLegalLinks />}
    </div>
  )
}

export default SideBarNavigationItems
